module.exports = __webpack_public_path__ + "img/nicolas-pro.abc67f48.jpg";